import React from 'react';

import { EditIcon } from '@vlabs/icons';
import { Control, useModal } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { EditFaceInfoFormPoint3 } from './forms/EditFaceInfoForm.point3';
import type { FaceId } from '@vlabs/api/luna-api/model';

interface EditFaceInfoButtonProps {
  faceId: FaceId;
  onEditFaceInfo?: VoidFunction;
}

export function EditFaceInfoButtonPoint3({
  faceId,
  onEditFaceInfo = undefined,
}: EditFaceInfoButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const modal = useModal();

  return (
    <React.Fragment>
      {modal.wrap(
        <EditFaceInfoFormPoint3
          faceId={faceId}
          onCancel={modal.close}
          onSubmit={() => {
            modal.close();
            onEditFaceInfo?.();
          }}
        />,
      )}

      <Control.Button
        icon={<EditIcon />}
        onClick={modal.open}
        size="small"
        variant="flat"
      >
        {t('face-page:edit_face_info.edit_face_button')}
      </Control.Button>
    </React.Fragment>
  );
}
